import styled from 'styled-components'
export const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`
